import { useState, useEffect } from 'react';

/** Header disclosure state and shared outside-click dismissal. */
export const useHeaderDropdowns = () => {
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [siteDropdownOpen, setSiteDropdownOpen] = useState(false);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = () => {
      setSiteDropdownOpen(false);
      if (languageDropdownOpen) {
        setLanguageDropdownOpen(false);
      }
      if (userDropdownOpen) {
        setUserDropdownOpen(false);
      }
    };

    if (languageDropdownOpen || userDropdownOpen || siteDropdownOpen) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [languageDropdownOpen, userDropdownOpen, siteDropdownOpen]);

  return {
    languageDropdownOpen, setLanguageDropdownOpen, userDropdownOpen, setUserDropdownOpen,
    siteDropdownOpen, setSiteDropdownOpen,
  };
};
